import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {signedIn, signIn, signOut} from "../auth-actions";
import {setNotification} from "../../notifications/notifications-actions";
import * as types from "../../types";
import {push} from 'connected-react-router'
import {FormattedMessage, injectIntl} from "react-intl";
import Notifications from "../../notifications/components/notifications";
import SignInForm from './sign-in-form';
import {withRouter} from "react-router-dom";

class SignIn extends React.Component {

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            let { from } = this.props.location.state || { from: { pathname: '/' } };
            nextProps.push(from);
        }
    }

    login = (values, form) => {
        this.props.signIn(values.email,values.password)
            .then((response) => {
                if (response.type === types.AUTH_SIGN_IN_SUCCESS) {
                    this.props.setNotification('success', this.props.intl.formatMessage({id: 'app.auth.sign_in.message.success'}));
                } else {
                    if ( response.payload.response.error ) {
                        this.props.setNotification('warning', response.payload.response.error);
                    } else {
                        this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                    }
                }
            }).catch((error) => {
                console.log(error);
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
        }).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        const { destination } = this.props;

        if (destination === 'inapp') {
            return (
                <div className='container'>
                    <Notifications/>
                    <div className='row'>
                        <div className='col-sm-6 col-lg-4 m-auto pt-5'>
                            <FormattedMessage id='app.auth.sign_in.title'>{(txt) => (<h1>{txt}</h1>)}</FormattedMessage>
                            <SignInForm handleSubmit={this.login} initialValues={{email: '', password: ''}}/>
                        </div>
                    </div>
                </div>
            )
        }

        const previousPath = this.props.history.createHref({pathname: this.props.auth.previousPath});

        let location = `/auth/saml/login?type=${destination}&RelayState=${encodeURIComponent(process.env.BASE_URL + previousPath)}`;
        window.location = location;

        return (
            <section className='bg-gray full-height'>
                <div className='container'>
                    <Notifications/>
                    <script>window.location = {`"/auth/saml/login?type=${this.props.destination}"`};</script>
                    <FormattedMessage id='app.auth.sign_in.title'>{(txt) => (<h1>{txt}</h1>)}</FormattedMessage>
                    <p><FormattedMessage id='app.auth.sign_in.redirection'/> <a className='link-orange' href={location}><FormattedMessage id='app.auth.sign_in.here'/></a></p>
                </div>
            </section>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth,
        destination: ownProps.destination
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        signedIn: signedIn,
        signIn: signIn,
        signOut: signOut
    }, dispatch);
}

export default withRouter(injectIntl(connect(mapStateToProps, matchDispatchToProps)(SignIn)));
